export default {
  getItineraryDays(state) {
    return state.itineraryDays;
  },
  getGeneratedDays(state) {
    return state.generatedDays;
  },
  getTotalItineraryDays(state) {
    return state.totalItineraryDays;
  },
  getTemplateItineraryDays(state) {
    return state.templateItineraryDays;
  },
  isLoading(state) {
    return state.isLoading;
  },
};
